import type { App } from 'vue';
import type { Router } from 'vue-router';

import * as Sentry from '@sentry/vue';

export function setupSentry(app: App, router: Router) {
  Sentry.init({
    app,
    dsn: 'https://cd3b3489021f4ac3926dc451da09200a@sentry.sconai.com/3',
    release: WEB_VERSION,
    environment: import.meta.env.MODE,

    // 성능
    tracesSampleRate: import.meta.env.MODE === 'prod' ? 0.05 : 0.2,

    // 세션 녹화
    replaysOnErrorSampleRate: 0.3, // 에러 세션 녹화 비율 (100%)
    replaysSessionSampleRate: 0.0, // 일반 세션 녹화 비율 (10%)

    integrations: [
      // 라우트
      Sentry.browserTracingIntegration({ router, routeLabel: 'path' }),

      // 추적
      Sentry.vueIntegration({
        tracingOptions: {
          // 컴포넌트 추적 활성화
          trackComponents: true,
          // 라이프사이클 훅 추적 대상
          hooks: ['mount', 'update', 'unmount'],
        },
      }),

      // 화면 녹화 차단
      Sentry.replayIntegration({
        // 화면 텍스트 마스킹 여부
        maskAllText: false,
        // 이미지/영상 차단 여부
        blockAllMedia: false,
      }),

      // TODO: 디스크 임시조치
      // Sentry.captureConsoleIntegration({
      //   levels: ['error'],
      // }),
    ],

    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Network request failed',
      'Failed to fetch',
      /^Script error/,
    ],

    // Sentry 활성화
    enabled: window.location.hostname !== 'localhost',
  });
}
